import { render, staticRenderFns } from "./dataTemplate.vue?vue&type=template&id=0c615dd5&scoped=true&"
import script from "./dataTemplate.vue?vue&type=script&lang=js&"
export * from "./dataTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dataTemplate.vue?vue&type=style&index=0&id=0c615dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c615dd5",
  null
  
)

export default component.exports